////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import { isNull } from 'lodash'
import { useRouteMatch } from 'react-router'
import styled from 'styled-components'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import moment from 'moment'
///////COMPONENTS///////
import { articleLifeManagerActionCreators } from '../../../../../store/actions'
import ArticleDatePicker from '../ArticleDatePicker'

/////////STYLED/////////
const ScheduledActivateActionWrapper = styled.div``
/////////STYLED/////////

//[63]_j): SCHEDULED ACTIVATION ITEM
const ScheduledActivateAction = (props) => {
	const match = useRouteMatch()

	const { translations, articleLifeManager } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			articleLifeManager: state.articleLifeManager,
		}),
		shallowEqual
	)

	const actionsArticleLifeManager = bindActionCreators(articleLifeManagerActionCreators, useDispatch())

	const [dateLimit, setDateToModify] = useState(new Date())

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleChangeDate = (date) => {
		setDateToModify(date)
	}

	const handleValidate = () => {
		actionsArticleLifeManager.postScheduleActivateAction(match.params.id, 'ScheduledActivateAction', dateLimit)
		handleCloseDatePicker()
	}

	const handleCloseDatePicker = () => {
		props.scheduledActivateAction.close()
	}

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (isNull(props.scheduledActivateAction?.item?.dateLimit))
			if (props.scheduledActivateAction.show) {
				handleChangeDate(new Date())
			}
	}, [props.scheduledActivateAction.show])

	useEffect(() => {
		if (articleLifeManager?.isUpdate) props.scheduledActivateAction.close()
	}, [articleLifeManager?.isUpdate])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<ScheduledActivateActionWrapper>
			<ArticleDatePicker
				showModal={props.scheduledActivateAction.show}
				date={dateLimit}
				handleValidate={handleValidate}
				handleClose={handleCloseDatePicker}
				handleChangeDate={handleChangeDate}
				title={translations['modal__itemRef__timeline_action_activation_scheduled_title']}
				priorLimit={moment().add(1, 'days').toDate()}
			/>
		</ScheduledActivateActionWrapper>
	)
}

ScheduledActivateAction.propTypes = {}

ScheduledActivateAction.defaultPropTypes = {}

export default ScheduledActivateAction
